import { Box } from "@mui/system";

const Loader = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <img src="/images/loader2.gif" alt="Loading, please wait..." style={{ width: '145px', height: '145px' }} />
    </Box>
  );
};

export default Loader;
